<e360-root-layout>
  <div class="m-auto w-100">
    <div class="alert my-0 mx-2" [class.alert-danger]="isError" role="alert">
      <span>{{ message | translate }}</span>
      @if (signInLink) {
        <span [innerHTML]="'ALERT_PAGE.SIGN_IN_AGAIN' | translate: { signInLink }"></span>
      }
    </div>
  </div>
</e360-root-layout>
